export default function (value, minPrice) {
  let numberValue = (value || 0)
    .replace(/[^\d,]*/g, '')
    .replace(/,/g, '.')

  numberValue = parseFloat(numberValue)

  return numberValue >= minPrice
}
